export class Servico {
  ativado = true;
  codigo = null;
  nome = null;
  descricao = null;
  grupoServicoId = null;
  precoServico = null;

  constructor(servico) {
    this.ativado = servico.ativado;
    this.codigo = servico.codigo;
    this.nome = servico.nome;
    this.descricao = servico.descricao;
    this.grupoServicoId = servico.grupoServicoId;
    this.precoServico = servico.precoServico;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeAutoComplete(name, value) {
    this[name] = value ? value.id : null;
  }
}
